/* istanbul ignore file */

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from 'src/layout/App'
import reportWebVitals from './reportWebVitals'

/* Context */
import ApiContext, { defaultContext } from 'src/ApiContext'
import { AppContextProvider, initialState } from 'src/AppContext'

/* Types */
import { isActiveUser } from 'src/types/user'

/* Styles */
import 'src/style/bootstrap.scss'
import 'src/style/dark-mode.scss'

const container = document.getElementById('root')!
const root = createRoot(container)

/* Auto-Login */
const localUser = localStorage.getItem('User')
const parsedUser = localUser ? JSON.parse(localUser) : null
if (isActiveUser(parsedUser)) initialState.user = parsedUser

root.render(
  <React.StrictMode>
    <AppContextProvider startState={initialState}>
      <ApiContext.Provider value={defaultContext}>
        <App />
      </ApiContext.Provider>
    </AppContextProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()